import { functions, httpsCallable } from '@/firebase'
async function getAllStudios() {
    const cloudFn = httpsCallable(functions, 'getAllWebAppStudios')
    const result = await cloudFn()
    return result.data.docs
}

export default getAllStudios
